const getICMS = (imposto) =>{

    //CST DE ICMS
    if(imposto.ICMS.ICMS00){
      return(imposto.ICMS.ICMS00)
    }
    if(imposto.ICMS.ICMS10){
      return(imposto.ICMS.ICMS10)
    }
    if(imposto.ICMS.ICMS20){
      return(imposto.ICMS.ICMS20)
    }
    if(imposto.ICMS.ICMS30){
      return(imposto.ICMS.ICMS30)
    }
    if(imposto.ICMS.ICMS40){
      return(imposto.ICMS.ICMS40)
    }
    if(imposto.ICMS.ICMS50){
      return(imposto.ICMS.ICMS50)
    }
    if(imposto.ICMS.ICMS60){
      return(imposto.ICMS.ICMS60)
    }
    if(imposto.ICMS.ICMS70){
      return(imposto.ICMS.ICMS70)
    }
    if(imposto.ICMS.ICMS90){
      return(imposto.ICMS.ICMS90)
    }
    if(imposto.ICMS.ICMSST){
      return(imposto.ICMS.ICMSST)
    }
    
    //CSOSN
    if(imposto.ICMS.ICMSSN101){
      return(imposto.ICMS.ICMSSN101)
    }
    if(imposto.ICMS.ICMSSN102){
      return(imposto.ICMS.ICMSSN102)
    }
    if(imposto.ICMS.ICMSSN103){
      return(imposto.ICMS.ICMSSN103)
    }
    if(imposto.ICMS.ICMSSN201){
      return(imposto.ICMS.ICMSSN201)
    }
    if(imposto.ICMS.ICMSSN202){
      return(imposto.ICMS.ICMSSN202)
    }
    if(imposto.ICMS.ICMSSN203){
      return(imposto.ICMS.ICMSSN203)
    }
    if(imposto.ICMS.ICMSSN300){
      return(imposto.ICMS.ICMSSN300)
    }
    if(imposto.ICMS.ICMSSN400){
      return(imposto.ICMS.ICMSSN400)
    }
    if(imposto.ICMS.ICMSSN500){
      return(imposto.ICMS.ICMSSN500)
    }
    if(imposto.ICMS.ICMSSN900){
      return(imposto.ICMS.ICMSSN900)
    }
  }

  const setICMS = (oICMS) =>{
    //se for cst
    if(oICMS.CST){
      if (oICMS.CST._text === '00'){
        const retorno = {
            ICMS00:oICMS
        }
        return(retorno);
      }
      
      if (oICMS.CST._text === '10'){
        const retorno = {
          ICMS10:oICMS
        }
        return(retorno);
      } 
  
      if (oICMS.CST._text === '20'){
        const retorno = {
          ICMS20:oICMS 
        }
        return(retorno);
      } 
  
      if (oICMS.CST._text === '30'){
        const retorno = {
          ICMS30:oICMS
        }
        return(retorno);
      } 
  
      if (oICMS.CST._text === '40'){
        const retorno = {
          ICMS40:oICMS
        }
        return(retorno);
      } 
  
      if (oICMS.CST._text === '50'){
        const retorno = {
          ICMS50:oICMS
        }
        return(retorno);
      } 
  
      if (oICMS.CST._text === '60'){
        const retorno = {
          ICMS60:oICMS
        }
        console.log(retorno);
        return(retorno);
      } 
  
      if (oICMS.CST._text === '70'){
        const retorno = {
          ICMS70:oICMS
        }
        return(retorno);
      } 
  
      if (oICMS.CST._text === '90'){
        const retorno = {
          ICMS90:oICMS
        }
        return(retorno);
      } 
    }
    //se for CSOSN
    if(oICMS.CSOSN){

      if (oICMS.CSOSN._text === '101'){
        const retorno = {
          ICMSSN101:oICMS
        }
        return(retorno);
      }

      if (oICMS.CSOSN._text === '102'){
        const retorno = {
          ICMSSN102:oICMS
        }
        return(retorno);
      }

      if (oICMS.CSOSN._text === '103'){ return({ ICMSSN103:oICMS }); }
      if (oICMS.CSOSN._text === '201'){ return({ ICMSSN201:oICMS }); }
      if (oICMS.CSOSN._text === '202'){ return({ ICMSSN202:oICMS }); }
      if (oICMS.CSOSN._text === '203'){ return({ ICMSSN203:oICMS }); }
      if (oICMS.CSOSN._text === '300'){ return({ ICMSSN300:oICMS }); }

      if (oICMS.CSOSN._text === '400'){
        const retorno = {
          ICMSSN400:oICMS
        }
        return(retorno);
      }

      if (oICMS.CSOSN._text === '500'){
        const retorno = {
          ICMSSN500:oICMS
        }
        return(retorno);
      }

      if (oICMS.CSOSN._text === '900'){
        const retorno = {
          ICMSSN900:oICMS
        }
        return(retorno);
      }

    }

  }

  const CSTxmlToCST = (imposto) =>{
   
    if(imposto.ICMS.ICMS00){
      return(imposto.ICMS.ICMS00.orig._text + imposto.ICMS.ICMS00.CST._text)
    }
    if(imposto.ICMS.ICMS10){
      return(imposto.ICMS.ICMS10.orig._text + imposto.ICMS.ICMS10.CST._text)
    }
    if(imposto.ICMS.ICMS20){
      return(imposto.ICMS.ICMS20.orig._text + imposto.ICMS.ICMS20.CST._text)
    }
    if(imposto.ICMS.ICMS30){
      return(imposto.ICMS.ICMS30.orig._text + imposto.ICMS.ICMS30.CST._text)
    }
    if(imposto.ICMS.ICMS40){
      return(imposto.ICMS.ICMS40.orig._text + imposto.ICMS.ICMS40.CST._text)
    }
    if(imposto.ICMS.ICMS50){
      return(imposto.ICMS.ICMS50.orig._text + imposto.ICMS.ICMS50.CST._text)
    }
    if(imposto.ICMS.ICMS60){
      return(imposto.ICMS.ICMS60.orig._text + '' + imposto.ICMS.ICMS60.CST._text)
    }
    if(imposto.ICMS.ICMS70){
      return(imposto.ICMS.ICMS70.orig._text + imposto.ICMS.ICMS70.CST._text)
    }
    if(imposto.ICMS.ICMS90){
      return(imposto.ICMS.ICMS90.orig._text + imposto.ICMS.ICMS90.CST._text)
    }  
    if(imposto.ICMS.ICMSST){
      return(imposto.ICMS.ICMSST.orig._text + imposto.ICMS.ICMSST.CST._text)
    }  

    //CSOSN
    if(imposto.ICMS.ICMSSN101){
      return(imposto.ICMS.ICMSSN101.orig._text + imposto.ICMS.ICMSSN101.CSOSN._text)
    }
    if(imposto.ICMS.ICMSSN102){
      return(imposto.ICMS.ICMSSN102.orig._text + imposto.ICMS.ICMSSN102.CSOSN._text)
    }
    if(imposto.ICMS.ICMSSN103){
      return(imposto.ICMS.ICMSSN103.orig._text + imposto.ICMS.ICMSSN103.CSOSN._text)
    }
    if(imposto.ICMS.ICMSSN201){
      return(imposto.ICMS.ICMSSN201.orig._text + imposto.ICMS.ICMSSN201.CSOSN._text)
    }
    if(imposto.ICMS.ICMSSN202){
      return(imposto.ICMS.ICMSSN202.orig._text + imposto.ICMS.ICMSSN202.CSOSN._text)
    }
    if(imposto.ICMS.ICMSSN203){
      return(imposto.ICMS.ICMSSN203.orig._text + imposto.ICMS.ICMSSN203.CSOSN._text)
    }
    if(imposto.ICMS.ICMSSN300){
      return(imposto.ICMS.ICMSSN300.orig._text + imposto.ICMS.ICMSSN300.CSOSN._text)
    }
    if(imposto.ICMS.ICMSSN400){
      return(imposto.ICMS.ICMSSN400.orig._text + imposto.ICMS.ICMSSN400.CSOSN._text)
    }
    if(imposto.ICMS.ICMSSN500){
      return(imposto.ICMS.ICMSSN500.orig._text + imposto.ICMS.ICMSSN500.CSOSN._text)
    }
    if(imposto.ICMS.ICMSSN900){
      return(imposto.ICMS.ICMSSN900.orig._text + imposto.ICMS.ICMSSN900.CSOSN._text)
    }
  }
  
  const aliquotaXMLtoAliquota = (imposto)=>{
    if(imposto.ICMS.ICMS00){ return imposto.ICMS.ICMS00.pICMS._text; }
    else if(imposto.ICMS.ICMS10){ return imposto.ICMS.ICMS10.pICMS._text; }
    else if(imposto.ICMS.ICMS20){ return imposto.ICMS.ICMS20.pICMS._text; }
    else if(imposto.ICMS.ICMS30){ return imposto.ICMS.ICMS30.pICMS ? imposto.ICMS.ICMS30.pICMS._text : '0'; }
    else if(imposto.ICMS.ICMS40){ return imposto.ICMS.ICMS40.pICMS ? imposto.ICMS.ICMS40.pICMS._text : '0'; }
    else if(imposto.ICMS.ICMS50){ return imposto.ICMS.ICMS50.pICMS ? imposto.ICMS.ICMS50.pICMS._text : '0'; }
    else if(imposto.ICMS.ICMS60){ return imposto.ICMS.ICMS60.pICMS ? imposto.ICMS.ICMS60.pICMS._text : '0'; }
    else if(imposto.ICMS.ICMS70){ return imposto.ICMS.ICMS70.pICMS ? imposto.ICMS.ICMS70.pICMS._text : '0'; }
    else if(imposto.ICMS.ICMS90){ return imposto.ICMS.ICMS90.pICMS ? imposto.ICMS.ICMS90.pICMS._text : '0'; }
    else if(imposto.ICMS.ICMSST){ return imposto.ICMS.ICMSST.pICMS ? imposto.ICMS.ICMSST.pICMS._text : '0'; }
    else if(imposto.ICMS.ICMSSN101){ return imposto.ICMS.ICMSSN101.pCredSN ? imposto.ICMS.ICMSSN101.pCredSN._text : '0'; }
    else if(imposto.ICMS.ICMSSN201){ return imposto.ICMS.ICMSSN201.pCredSN ? imposto.ICMS.ICMSSN201.pCredSN._text : '0'; }
    else if(imposto.ICMS.ICMSSN900){ return imposto.ICMS.ICMSSN900.pICMS ? imposto.ICMS.ICMSSN900.pICMS._text : '0'; }
    return '0';
  } 
  
  const valorSTxmlToValorST = (imposto)=>{
    if(imposto.ICMS.ICMS00){ return '0'; }
    else if(imposto.ICMS.ICMS10){ return imposto.ICMS.ICMS10.vICMSST ? imposto.ICMS.ICMS10.vICMSST._text : '0'; }
    else if(imposto.ICMS.ICMS20){ return '0'; }
    else if(imposto.ICMS.ICMS30){ return imposto.ICMS.ICMS30.vICMSST ? imposto.ICMS.ICMS30.vICMSST._text : '0'; }
    else if(imposto.ICMS.ICMS40){ return '0'; }
    else if(imposto.ICMS.ICMS50){ return '0'; }
    else if(imposto.ICMS.ICMS60){ return imposto.ICMS.ICMS60.vICMSST ? imposto.ICMS.ICMS60.vICMSST._text : '0'; }
    else if(imposto.ICMS.ICMS70){ return imposto.ICMS.ICMS70.vICMSST ? imposto.ICMS.ICMS70.vICMSST._text : '0'; }
    else if(imposto.ICMS.ICMS90){ return imposto.ICMS.ICMS90.vICMSST ? imposto.ICMS.ICMS90.vICMSST._text : '0'; }
    else if(imposto.ICMS.ICMSST){ return imposto.ICMS.ICMSST.vICMSST ? imposto.ICMS.ICMSST.vICMSST._text : '0'; }
    return '0';
  } 

  const valorFCPSTxmlToValorFCPST = (imposto)=>{
    let retorno = '0';
    if(imposto.ICMS.ICMS00){
      retorno = imposto.ICMS.ICMS00.vFCPST ? imposto.ICMS.ICMS00.vFCPST._text : '0';
    }
    if(imposto.ICMS.ICMS10){
      retorno = imposto.ICMS.ICMS10.vFCPST ? imposto.ICMS.ICMS10.vFCPST._text : '0';
    }
    if(imposto.ICMS.ICMS20){
      retorno = imposto.ICMS.ICMS20.vFCPST ? imposto.ICMS.ICMS20.vFCPST._text : '0';
    }
    if(imposto.ICMS.ICMS30){
      retorno = imposto.ICMS.ICMS30.vFCPST ? imposto.ICMS.ICMS30.vFCPST._text : '0';
    }
    if(imposto.ICMS.ICMS40){
      retorno = imposto.ICMS.ICMS40.vFCPST ? imposto.ICMS.ICMS40.vFCPST._text : '0';
    }
    if(imposto.ICMS.ICMS50){
      retorno = imposto.ICMS.ICMS50.vFCPST ? imposto.ICMS.ICMS50.vFCPST._text : '0';
    }
    if(imposto.ICMS.ICMS60){
      retorno = imposto.ICMS.ICMS60.vFCPST ? imposto.ICMS.ICMS60.vFCPST._text : '0';
    }
    if(imposto.ICMS.ICMS70){
      retorno = imposto.ICMS.ICMS70.vFCPST ? imposto.ICMS.ICMS70.vFCPST._text : '0';
    }
    if(imposto.ICMS.ICMS90){
      retorno = imposto.ICMS.ICMS90.vFCPST ? imposto.ICMS.ICMS90.vFCPST._text : '0';
    } 
    if(imposto.ICMS.ICMSST){
      retorno = imposto.ICMS.ICMSST.vFCPST ? imposto.ICMS.ICMSST.vFCPST._text : '0';
    }  
    return(retorno);
  } 

export {setICMS, getICMS, CSTxmlToCST, aliquotaXMLtoAliquota, valorSTxmlToValorST, valorFCPSTxmlToValorFCPST}